import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { fetchItems } from "../../actions/interiorActions";
import {
  makeInteriorPreviewsSelector,
  makeInteriorPreviewsAnyKeySelector,
  makeInteriorPreviewsFetchStatusSelector,
} from "../../selectors/interiorPreviews";
import { INTERIOR_SHAPE } from "../../constants/interiorConstants";
import { COLLECTION_FETCH_STATUS_SHAPE } from "../../selectors/collections";
import LoadableCollection from "../../components/ui/loadable/collection";


export function withInteriors(WrappedComponent) {

  const WithInteriors = class extends Component {

    shouldComponentUpdate(prevProps) {
      if (prevProps.fetchStatus && prevProps.fetchStatus.isFetching) {
        return false
      } else {
        return true
      }
    }

    fetchInteriors = (currentPage = 1) => {
      const { fetchItems, fetchStatus } = this.props;

      if (!fetchStatus.isFetching) {
        fetchItems(currentPage);
      }
    };

    render() {
      const { interiors, pagination, fetchStatus, children, ...restProps } = this.props;

      return (
        <LoadableCollection fetchStatus={fetchStatus}>
          {
            () => <WrappedComponent
                    {...restProps}
                    interiors={interiors}
                    pagination={pagination}
                    fetchStatus={fetchStatus}
                    fetchInteriors={this.fetchInteriors}
                  />
          }
        </LoadableCollection>
      )
    }
  };

  WithInteriors.propTypes = {
    interiors: PropTypes.arrayOf(PropTypes.shape(INTERIOR_SHAPE)),
    fetchStatus: PropTypes.shape(COLLECTION_FETCH_STATUS_SHAPE).isRequired,
  };

  const interiorsSelector = makeInteriorPreviewsSelector();
  const interiorsPaginationSelector = makeInteriorPreviewsAnyKeySelector('pagination');
  const interiorsFetchStatusSelector = makeInteriorPreviewsFetchStatusSelector();

  function mapStateToProps(state) {
    return {
      interiors: interiorsSelector(state),
      pagination: interiorsPaginationSelector(state) || {},
      fetchStatus: interiorsFetchStatusSelector(state),
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      fetchItems,
    }, dispatch)
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithInteriors);
}